import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const UserSidebar = withSafeSuspense(
  lazy(
    () => import(/* webpackChunkName: 'user_profile_sidebar' */'./sidebar/user')
      .then((module) => ({ default: module.UserSidebar }))
  ), null
)

export const InvitationSidebar = withSafeSuspense(
  lazy(
    () => import(/* webpackChunkName: 'user_profile_sidebar' */'./sidebar/invitation')
      .then((module) => ({ default: module.InvitationSidebar }))
  ), null
)

export const UserInfoAvatar = withSafeSuspense(
  lazy(
    () => import(/* webpackChunkName: 'user_profile_avatar' */'./avatar')
      .then((module) => ({ default: module.UserInfoAvatar }))
  ), null
)
